import React from "react";

const WorkExchangeContext = React.createContext({
  workExchangeFilter: undefined,
  setWorkExchangeFilter: () => {},
});

export default WorkExchangeContext;
